import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import { Box, Button, Icon, Stack, TextField, Typography } from '@mui/material'
import { useState } from 'react'

import { useTests } from '../Contexts/TestsContext'
import Scanner from './QRCodeScanner'

const SearchBySerialNumber = ({ setEnableButton = () => { }, data, setData = () => { } }) => {

  const { useFetchGateway } = useTests()

  const [isScanning, setIsScanning] = useState(false)
  const [serial, setSerial] = useState('')

  const handleChangeSerial = (event) => {
    setSerial(event.target.value)
    useFetchGateway({ serial: event.target.value, technology: ['Wmbus+Lorawan', 'Lorawan'] })
      .then(({ data }) => {
        if (data.length == 1) {
          setData(data[0])
          setEnableButton(true)
        }
      }).catch((err) => {
        if (err.status === 404) {
          alert('Gateway non trovato, controlla il numero seriale e riprova')
        }
      })
  }

  const handleScanCode = () => {
    setIsScanning(true)
  }

  return (
    <>
      {data == null ? <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        rowGap={1}
        marginTop={10}
      >
        <TextField
          id="gateway-serial"
          name="gatewaySerial"
          type="text"
          variant="filled"
          placeholder="Inserisci numero seriale"
          value={serial}
          onInput={handleChangeSerial}
        />
        <Button variant="text" startIcon={<QrCodeScannerIcon />} onClick={handleScanCode}>
          Leggi seriale automaticamente
        </Button>
        {isScanning && <Scanner setCode={handleChangeSerial} setIsScanning={setIsScanning} />}
      </Box> : <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        rowGap={1}
        marginTop={2}>
        <Icon color="success" sx={{ fontSize: '8rem' }}>
          <CheckCircleOutlineIcon sx={{ fontSize: '8rem' }} />
        </Icon>
        <Typography variant="h5" fontWeight="bold" color='success'>
          Gateway rilevato
        </Typography>
        <Stack display="flex" flexDirection="column" alignItems="start" rowGap={1} marginTop={5}>
          <Typography variant="body1">
            LoRaWAN GatewayID
          </Typography>
          <TextField
            type="text"
            variant='filled'
            size='small'
            disabled
            value={data.gatewayId || ''}
          />

          <Typography variant="body1">
            WmBUS GatewayID
          </Typography>
          <TextField
            type="text"
            variant='filled'
            size='small'
            disabled
            value={data.wmbusId || ''}
          />

          <Typography variant="body1">
            Indirizzo IP
          </Typography>
          <TextField
            type="text"
            variant='filled'
            size='small'
            disabled
            value={data.ip || ''}
          />
        </Stack>
      </Box>}

    </>
  )
}

export default SearchBySerialNumber